import {callURL} from './call';
import messageShow from "./messageShow";
import {clientURL, signerURL} from "../url";

const login= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            const onResultCode= (resultCode) =>
            {
                if(resultCode && resultCode[1].success)
                    window.location.href=clientURL + "?appUser=" + result[1].userName + "&appCode=" + resultCode[1].result.appCode + "&usePAD=false&logout=true";
                else
                    dispatch(messageShow({message: result[1].error, type: 'error'}));
            };
            dispatch(callURL(signerURL,"rest/UserService/generateAppCode", {},onResultCode));
        }
        else
            dispatch(messageShow({message: result[1].error, type: 'error'}));
    }
    dispatch(callURL(signerURL,"rest/LoginService/checkBasicAuthentication",formValues,onResult));
};
export default login;